import { render } from "./BackButtonSingelPage.vue?vue&type=template&id=02b5c283"
import script from "./BackButtonSingelPage.vue?vue&type=script&lang=js"
export * from "./BackButtonSingelPage.vue?vue&type=script&lang=js"

import "./BackButtonSingelPage.vue?vue&type=style&index=0&id=02b5c283&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__